module.exports = __webpack_public_path__ + "static/media/mobileCharlieIcon.fca3e7d8.svg";